import { render, staticRenderFns } from "./realNameAuthGate.vue?vue&type=template&id=2694c29b&scoped=true&"
import script from "./realNameAuthGate.vue?vue&type=script&lang=js&"
export * from "./realNameAuthGate.vue?vue&type=script&lang=js&"
import style0 from "./realNameAuthGate.vue?vue&type=style&index=0&id=2694c29b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694c29b",
  null
  
)

export default component.exports